// extracted by mini-css-extract-plugin
export default {"swiper_container":"style_swiper_container__qLBUc","swiper_slide":"style_swiper_slide__du80I","swiper_slide_img":"style_swiper_slide_img__RM6WI"};